export const PUBLICATION = {
  PUB_ACTIVITY_REPORT: 'FILTERS_PUBLICATION_ACTIVITY_REPORT',
  PUB_FULL_YEAR_RESULTS: 'FILTERS_PUBLICATION_FULL_YEAR_RESULTS',
  PUB_GREEN_BOND: 'FILTERS_PUBLICATION_GREEN_BOND',
  PUB_HALF_RESULTS: 'FILTERS_PUBLICATION_HALF_RESULTS',
  PUB_INVESTOR_PRESENTATIONS: 'FILTERS_PUBLICATION_INVESTOR_PRESENTATIONS',
  PUB_POSTEO_BOOK: 'FILTERS_PUBLICATION_POSTEO_BOOK',
  PUB_POSTEO_MAGAZINE: 'FILTERS_PUBLICATION_POSTEO_MAGAZINE',
  PUB_PRESS_RELEASE: 'FILTERS_PUBLICATION_PRESS_RELEASE',
  PUB_REFERENCE_DOCUMENT: 'FILTERS_PUBLICATION_REFERENCE_DOCUMENT',
  PUB_RSE_REPORT: 'FILTERS_PUBLICATION_RSE_REPORT',
  PUB_SOCIAL_REPORT: 'FILTERS_PUBLICATION_SOCIAL_REPORT',
  PUB_STUDY_BAROMETRE: 'FILTERS_PUBLICATION_STUDY_BAROMETRE',
  PUB_THEME_MEMENTO: 'FILTERS_PUBLICATION_THEME_MEMENTO',
  PUB_UNIVESAL_REGISTRATION_DOCUMENT:
    'FILTERS_PUBLICATION_UNIVERSAL_REGISTRATION_DOCUMENT',
  PUB_WHITE_PAPER: 'FILTERS_PUBLICATION_WHITE_PAPER',
  PUB_ENTERPRISE_GOVERNMENT_REPORT:
    'FILTERS_PUBLICATION_ENTERPRISE_GOVERNMENT_REPORT',
  PUB_VOTING_RIGHT_NB_ACTIONS: 'FILTERS_PUBLICATION_VOTING_RIGHT_NB_ACTIONS',
};
